<ng-container *ngIf="reportLoaded">
    <section class="section-buttons">
        <button (click)="closeSettings()"  [matTooltip]="'Close'" matTooltipClass="tooltip-font-14">
            <i class="fal fa-times-circle"></i>
        </button>
        <button (click)="expandSettings()" [matTooltip]="page.reportExpanded?'Minimise':'Maximise'" matTooltipClass="tooltip-font-14">
            <i class="fal" [class]="page.reportExpanded?'fa-compress':'fa-expand'"></i>
        </button>
    </section>

    <app-reports-basic-info [report]="report" [infoAllColumns]="page.infoAllColumns" [gridItem]="gridItem"></app-reports-basic-info>

    <section>
        <h3>{{"dashboard:Report Settings" | i18next}}</h3>
        <div class="section-content settings-content">
            <div>
                <div>
                    <app-reports-date-picker [gridItem]="gridItem" (setPeriod)="setPeriod($event)" [showTitle]="true" [firstDate]="report?.firstDate"
                                             [dataAvailableFor]="report?.dataAvailableFor" [(data)]="rdp_data"></app-reports-date-picker>
                </div>
                <div *ngIf="isTimeRangeVisible()">
                    <span class="settings-sub-title">{{ 'dashboard:Limit Time Range' | i18next }}</span>
                    <div>
                        <mat-slide-toggle class="slide-limit-time" [color]="'#33C4B3'" [(ngModel)]="gridItem.setup.limitRange"></mat-slide-toggle>
                        <button mat-flat-button class="secondary-button" (click)="showLimitTimeRange()" [disabled]="!gridItem.setup.limitRange">
                            {{ 'dashboard:Time Range' | i18next }}
                        </button>
                    </div>
                </div>
                <div>
                    <span class="settings-sub-title empty"></span>
                    <div>
                        <button mat-flat-button class="secondary-button" (click)="page.settingsExpanded=!page.settingsExpanded">
                            <ng-container *ngIf="page.settingsExpanded">{{ 'dashboard:Hide Settings' | i18next }}</ng-container>
                            <ng-container *ngIf="!page.settingsExpanded">{{ 'dashboard:Show Settings' | i18next }}</ng-container>
                        </button>
                    </div>
                </div>
                <div>
                    <span class="settings-sub-title empty"></span>
                    <div>
                        <button mat-flat-button class="primary-button" (click)="viewReport()" [disabled]="!isSetupCompleted">
                            {{ 'dashboard:View Report' | i18next }}
                        </button>
                    </div>
                </div>
            </div>
            <div [@collapse]="!page.settingsExpanded" class="flex wrap settings-expanded">
                <h5>{{ 'dashboard:Additional Settings' | i18next }} </h5>
                <div *ngIf="serviceNumbers?.length>0" class="half-row">
                    <div class="title" [class.active]="serviceNumbersIsOpen">{{ 'dashboard:Service Number' | i18next}}
                    </div>
                    <ng-select [items]="serviceNumbers" bindLabel="key" bindValue="value" [(ngModel)]="gridItem.setup.serviceNumber" placeholder="{{ 'Select'| i18next }}"
                        [searchable]="false" (open)="serviceNumbersIsOpen=true" (close)="serviceNumbersIsOpen=false" (change)="notifyReportModified()">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" dropdownPosition="bottom">
                            <span class="item">{{item.value}}</span>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="item">{{item?.value}}</span>
                        </ng-template>
                    </ng-select>
                </div>
                <app-widget-report-columns-select [items]="columns" class="half-row" bindLabel="shortDescription" [model]="gridItem.setup.columns" [defaultColumns]="defaultColumns"
                                                  title="{{ 'dashboard:Select Columns' | i18next }}" bindValue="labelCode" (modelChange)="selectModelChange($event,'columns')">
                </app-widget-report-columns-select>
                <app-widget-type-select [widgetType]="gridItem.type" [showTooltip]="true" (modelChange)="gridItem.type=$event;notifyReportModified()" class="half-row"
                                        title="{{ 'dashboard:Visual Type' | i18next }}" [disabledItems]="visualTypeDisabledItems" hideLabelType="true">
                </app-widget-type-select>
                <div class="half-row" *ngIf="sysGroupByTime?.length>0">
                    <div class="mr5">
                        <div class="title ml5">{{ 'dashboard:Group by time' | i18next }}</div>
                        <ng-select [items]="sysGroupByTime" bindLabel="value" bindValue="key" [(ngModel)]="gridItem.setup.sysGroupByTime" placeholder="{{ 'Select'| i18next }}"
                                   [searchable]="false" class="group-select" (change)="notifyReportModified()">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" dropdownPosition="bottom">
                                <span>{{item.value}}</span>
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                <span class="item">{{item?.value}}</span>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div class="half-row" *ngIf="sysDimsForFilter.indexOf('A')>-1">
                    <div>
                        <app-widget-report-select [items]="agents$|async" bindLabel="fullName" [model]="gridItem.setup.A" title="{{ 'dashboard:Select Agents' | i18next }}"
                                                  bindValue="agentId" [(exclude)]="gridItem.setup.excludeA" (modelChange)="selectModelChange($event,'A')" class="filter-select">
                        </app-widget-report-select>
                    </div>
                </div>
                <div class="half-row" *ngIf="sysDimsForFilter.indexOf('G')>-1">
                    <div>
                        <app-widget-user-group-select [items]="userGroupsRes" bindLabel="usergroupName" [model]="gridItem.setup.G" title="{{ 'dashboard:Select User Groups' | i18next }}"
                            bindValue="usergroupId" [(exclude)]="gridItem.setup.excludeG" (modelChange)="selectModelChange($event,'G')" class="filter-select">
                        </app-widget-user-group-select>
                    </div>
                </div>
                <div class="half-row" *ngIf="sysDimsForFilter.indexOf('Q')>-1">
                    <div>
                        <app-widget-report-select [items]="queues$|async" bindLabel="description" [model]="gridItem.setup.Q" title="{{ 'dashboard:Select Queues' | i18next }}"
                            bindValue="queueKey" [(exclude)]="gridItem.setup.excludeQ" (modelChange)="selectModelChange($event,'Q')" class="filter-select">
                        </app-widget-report-select>
                    </div>
                </div>
                <div class="half-row" *ngIf="sysDimsForFilter.indexOf('T')>-1">
                    <div>
                        <app-widget-select [items]="terminatingNumbers$|async" bindLabel="terminNumber" [model]="gridItem.setup.T" title="{{ 'dashboard:Select Terminating Numbers' | i18next }}"
                            bindValue="terminNumber" [(exclude)]="gridItem.setup.excludeT" (modelChange)="selectModelChange($event,'T')" class="filter-select">
                        </app-widget-select>
                    </div>
                </div>
                <div class="half-row" *ngIf="sysDimsForFilter.indexOf('M')>-1">
                    <div>
                        <app-widget-report-select [items]="menus$|async" bindLabel="description" [model]="gridItem.setup.M" title="{{ 'dashboard:Select Menus' | i18next }}"
                            bindValue="menueId" [(exclude)]="gridItem.setup.excludeM" (modelChange)="selectModelChange($event,'M')" class="filter-select">
                        </app-widget-report-select>
                    </div>
                </div>
                <div class="half-row half-row-checkbox" *ngIf="sysAgentNoCalls" >
                  <div class="flex">
                    <label [for]="elAgentNoCalls.inputId">{{sysAgentNoCalls.prompt}}</label>
                    <mat-slide-toggle class="slide-limit-time" [color]="Primary" [(ngModel)]="gridItem.setup.sysAgentNoCalls" #elAgentNoCalls></mat-slide-toggle>
                  </div>
                </div>
                  <div class="half-row half-row-checkbox" *ngIf="sysShowEmpty" >
                    <div class="flex">
                      <label [for]="elShowEmpty.inputId">{{sysShowEmpty.prompt}}</label>
                      <mat-slide-toggle class="slide-limit-time" [color]="Primary" [(ngModel)]="gridItem.setup.sysShowEmpty" #elShowEmpty></mat-slide-toggle>
                    </div>
                </div>
                <div class="half-row" *ngIf="sysDimsForFilter.indexOf('N')>-1">
                    <div>
                        <app-widget-report-select [items]="accesspoints" bindLabel="description" [model]="gridItem.setup.N" title="{{ 'dashboard:Select Accesspoint' | i18next }}"
                            bindValue="accesspoint" [(exclude)]="gridItem.setup.excludeN" (modelChange)="selectModelChange($event,'N')" class="filter-select">
                        </app-widget-report-select>
                    </div>
                </div>
                <div [class]="filtersLengthIsEven()?'column-order-row-odd':'column-order-row-even'" *ngIf="showColumnButton && this.gridItem.type === 4">
                    <button mat-flat-button [ngClass]="['secondary-button', 'arrange-columns-button']" (click)="showColumnOrder=true">
                        <i class="fal fa-cog button-cog"></i> {{ 'dashboard:Column order' | i18next }}
                    </button>
                    <div class="column-order-wraper" *ngIf="showColumnOrder">
                        <div class="column-order-container"></div>
                        <div class="column-order-inner-container">
                            <div class="column-order-header">
                                <i class="fal fa-cog"></i>
                                <span style="flex-grow: 1;">{{ 'dashboard:Column order' | i18next }}</span>
                                <i class="fal fa-times-circle" (click)="showColumnOrder=false"></i>
                            </div>
                            <app-column-order [gridItem]="gridItem" [columns]="columns"
                                (columnOrderEvent)="columnOrderEvent($event)"></app-column-order>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-content-expand">
            <div (click)="page.settingsExpanded=!page.settingsExpanded">
                <i class="far fa-chevron-down" [class.fa-chevron-up]="page.settingsExpanded"></i>
            </div>
        </div>
    </section>
    <section class="section-report">
        <h3>{{"dashboard:Report" | i18next}}</h3>
        <div class="section-content">
            <div class="report-expandable" [class.report-expanded]="isReportFullscreen" #reportExpandable>
                <div class="report-expandable-inner">
                    <div class="report-expandable-header" [hidden]="!showReport">
                        <span class="report-short-description">{{report?.shortDescription}}</span>
                        <app-reports-date-picker [hidden]="!isReportFullscreen" [gridItem]="gridItem" (setPeriod)="setPeriod($event)" [showTitle]="false"
                                                 [firstDate]="report?.firstDate" [dataAvailableFor]="report?.dataAvailableFor" [(data)]="rdp_data"></app-reports-date-picker>
                        <div>
                            <button *ngIf="isReportFullscreen" class="primary-button" mat-flat-button (click)="viewReport()">
                                {{'dashboard:View Report' | i18next }}
                            </button>
                            <button *ngIf="isData" mat-flat-button [ngClass]="['secondary-button', 'export-button']" (click)="exportReport()" [disabled]="!canExport">
                                {{ 'dashboard:Add to Dashboard' | i18next }}
                            </button>
                            <button *ngIf="isData" mat-flat-button [ngClass]="['secondary-button', 'download-button']" (click)="openDownloadDialog()">
                                <i class="far fa-download"></i> Download Report</button>
                            <button *ngIf="isData && secondDownloadButtonEnabled" mat-flat-button [ngClass]="['secondary-button', 'download-button']" (click)="exportTable2()">
                                  <i class="far fa-download"></i> Download Report 2</button>
                                <i class="fas" [class.fa-compress-alt]="isReportFullscreen"  [matTooltip]="isReportFullscreen ? 'Exit Full Screen' : 'Full Screen'" matTooltipClass="tooltip-font-14"
                            [class.fa-expand-alt]="!isReportFullscreen" (click)="toggleReportFullscreen()"></i>
                        </div>
                    </div>
                    <app-repQDetails *ngIf="showReport" [gridItem]="gridItem" [dataEquality]="dataEquality" [isStandAlone]="true" [generateNotifier]="generateNotifier$"
                                     [reportCode]="report?.report_Code" [reportTitle]="report?.shortDescription" (dataReceivedEvent)="dataReceived($event)"
                                     [downloadDialogNotifier]="downloadDialogNotifier$" [orderColumnsNotifier]="orderColumnsNotifier$">
                    </app-repQDetails>
                </div>
            </div>
        </div>
    </section>

    <app-reports-save-buttons [report]="report" [gridItem]="gridItem" (cancelButtonNotifier)="closeSettings()" (reportSavedNotifier)="reportSavedHandler()"
                              (saveAsDilogClosedNotifier)="saveAsDilogClosedHandler($event)"></app-reports-save-buttons>

    <div *ngIf="showColumnOrder" class="backdrop" (click)="showColumnOrder=false"></div>
</ng-container>

<app-data-loading *ngIf="!dataLoaded"></app-data-loading>
